export default __webpack_public_path__ + "static/media/icon-executive.961329d1.svg";